export default "/fonts/icomoon.svg?480480d2f1be708cf2c9e5f5c091fdab";